import LzMBase from '@lz-models/commons/Base';
import LzMOption from '@lz-models/commons/Option';

export default class PartyModel extends LzMBase {

    static TYPE_REGISTERED = 1;
    static TYPE_UNREGISTERED = 2;

    static TYPE_NAMES = {
        1: 'Registered',
        2: 'Unregistered',
    };

    /**
    * Party provinces (taken from FBR, see: Party.php Laravel Model for details).
    */
    static PROVINCE_BALOCHISTAN = 'BALOCHISTAN';
    static PROVINCE_AJK = 'AZAD JAMMU AND KASHMIR';
    static PROVINCE_CAPITAL = 'CAPITAL TERRITORY';
    static PROVINCE_KPK = 'KHYBER PAKHTUNKHWA';
    static PROVINCE_PUNJAB = 'PUNJAB';
    static PROVINCE_SINDH = 'SINDH';
    static PROVINCE_GILGIT = 'GILGIT BALTISTAN';

    constructor(model) {
        super(model);

        this.type = +(model?.type || 1);
        this.code = model?.code || '';
        this.address = model?.address || '';
        this.province = model?.province || '';
        this.strn = model?.strn || '';
        this.ntn = model?.ntn || '';
        this.strn = model?.strn || '';
    }

    static parseArray(data) {
        return LzMBase.parseArray(data, PartyModel);
    }

    static getTypeName(type) {
        return PartyModel.TYPE_NAMES[type] || 'n/a';
    }

    static getTypeOptions() {
        return [
            new LzMOption({ value: 1, text: 'Registered' }),
            new LzMOption({ value: 2, text: 'Unregistered' }),
        ];
    }

    static getProvinceOptions() {
        return [
            new LzMOption({ value: 'BALOCHISTAN', text: 'BALOCHISTAN' }),
            new LzMOption({ value: 'AZAD JAMMU AND KASHMIR', text: 'AZAD JAMMU AND KASHMIR' }),
            new LzMOption({ value: 'CAPITAL TERRITORY', text: 'CAPITAL TERRITORY' }),
            new LzMOption({ value: 'KHYBER PAKHTUNKHWA', text: 'KHYBER PAKHTUNKHWA' }),
            new LzMOption({ value: 'PUNJAB', text: 'PUNJAB' }),
            new LzMOption({ value: 'SINDH', text: 'SINDH' }),
            new LzMOption({ value: 'GILGIT BALTISTAN', text: 'GILGIT BALTISTAN' }),
        ];
    }

}
